import { Map as ImmutableMap } from 'immutable';
import { FetchPermissionsActionTypes } from '../actions/PermissionsActions';
import { handleActions } from 'flux-actions';
import Permission from '../records/Permission';
const initialState = ImmutableMap();
export default handleActions({
  [FetchPermissionsActionTypes.SUCCESS](state, action) {
    return state.withMutations(map => {
      if (!action.payload) {
        return;
      }
      action.payload.data.permissions.reduce((acc, item) => {
        if (!item.roleId) {
          return acc;
        }
        return acc.set(item.roleId, new Permission(item));
      }, map);
    });
  }
}, initialState);